import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {useDispatch} from 'react-redux';
import AbstractModalView from 'common/components/AbstractModalView';
import UploadedFilesGrid from 'common/components/UploadedFilesGrid';
import UploadedFilesSet from 'common/components/UploadedFilesSet';
import Empty from '../Empty';
import TabsHolder from '../TabsHolder';
import {getSharedFile} from '../../actions/files/getSharedFile';
import {getFile} from '../../actions/files/getFile';
import {copyOrderFile, copyPrivateFile, copySharedFile} from '../../actions/files/copySharedFile';
import filesList from '../../../common/assets/Layout-top-panel-5.svg';
import empty from '../../assets/nothing.svg';
import styles from './styles.module.scss';

const popupHeader = 'בחירה ממאגרי מידע';
const popupPrivateHeader = 'רשימת קבצים ממאגר פנימי';
const popupSharedHeader = 'רשימת קבצים ממאגר שיתופי';

const EmptyComponent = () => (
  <div className={styles.emptyContainer}>
    <Empty icon={empty} message={'ללא קבצים מצורפים'}/>
  </div>
);

const getPopupHeader = type => {
  switch (type) {
    case 'shared':
      return popupSharedHeader;
    case 'private':
      return popupPrivateHeader;
    case 'all':
    default:
      return popupHeader;
  }
};

const GridOrEmpty = (props) => (props.files && props.files.length > 0)
  ? (
    <div className={styles.uploadedFiles}>
      <UploadedFilesGrid {...props}/>
    </div>
  )
  : <EmptyComponent/>;

const SetOrEmpty = (props) => (props.files && props.files.length > 0)
  ? (
    <div className={styles.uploadedFiles}>
      <UploadedFilesSet {...props}/>
    </div>
  )
  : <EmptyComponent/>;

const ModalSharedFilesListView = ({
                                    shumaID,
                                    stepID,
                                    type,
                                    files = {
                                      order: [],
                                      shared: [],
                                      private: []
                                    },
                                    folderID,
                                    handleGetFilesLists,
                                    fileUploaded,
                                    customStylesContainer,
                                    fileTypeID,
                                    handleSubmit
                                  }) => {
  const dispatch = useDispatch();
  const getPrivateFile = ({shumaID, fileID}) => {
    return dispatch(getFile({shumaId: shumaID, fileID}));
  };

  const buildTablesOrTabs = (closeModal) => {
    switch (type) {
      case 'order':
        return (
          <SetOrEmpty
            files={files.order}
            shumaID={shumaID}
            stepID={stepID}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            copyFile={copyOrderFile}
            fileTypeID={fileTypeID}
            folderID={folderID}
          />
        );
      case 'shared':
        return (
          <GridOrEmpty
            files={files.shared}
            shumaID={shumaID}
            stepID={stepID}
            closeModal={closeModal}
            fileUploaded={fileUploaded}
            handleSubmit={handleSubmit}
            getFile={getSharedFile}
            copyFile={copySharedFile}
          />
        );
      case 'private':
        return (
          <GridOrEmpty
            files={files.private}
            shumaID={shumaID}
            stepID={stepID}
            closeModal={closeModal}
            fileUploaded={fileUploaded}
            handleSubmit={handleSubmit}
            getFile={getPrivateFile}
            showShumaId={true}
            copyFile={copyPrivateFile}
          />
        );
      case 'order-shared':
        return (
          <TabsHolder tabs={[
            {
              id: 0,
              title: 'קבצי הזמנה', //order
              content: (
                <SetOrEmpty
                  files={files.order}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  handleSubmit={handleSubmit}
                  copyFile={copyOrderFile}
                  fileTypeID={fileTypeID}
                  folderID={folderID}
                />
              )
            },
            {
              id: 1,
              title: 'מאגר שיתופי', //shared
              content: (
                <GridOrEmpty
                  files={files.shared}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  fileUploaded={fileUploaded}
                  handleSubmit={handleSubmit}
                  getFile={getSharedFile}
                  copyFile={copySharedFile}
                />
              )
            },
          ]}/>
        );
      case 'order-private':
        return (
          <TabsHolder tabs={[
            {
              id: 0,
              title: 'קבצי הזמנה', //order
              content: (
                <SetOrEmpty
                  files={files.order}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  handleSubmit={handleSubmit}
                  copyFile={copyOrderFile}
                  fileTypeID={fileTypeID}
                  folderID={folderID}
                />
              )
            },
            {
              id: 1,
              title: 'מאגר פנימי', // private
              content: (
                <GridOrEmpty
                  files={files.private}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  fileUploaded={fileUploaded}
                  handleSubmit={handleSubmit}
                  getFile={getPrivateFile}
                  showShumaId={true}
                  copyFile={copyPrivateFile}
                />
              )
            },
          ]}/>
        );
      case 'shared-private':
        return (
          <TabsHolder tabs={[
            {
              id: 0,
              title: 'מאגר פנימי', // private
              content: (
                <GridOrEmpty
                  files={files.private}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  fileUploaded={fileUploaded}
                  handleSubmit={handleSubmit}
                  getFile={getPrivateFile}
                  showShumaId={true}
                  copyFile={copyPrivateFile}
                />
              )
            },
            {
              id: 1,
              title: 'מאגר שיתופי', //shared
              content: (
                <GridOrEmpty
                  files={files.shared}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  fileUploaded={fileUploaded}
                  handleSubmit={handleSubmit}
                  getFile={getSharedFile}
                  copyFile={copySharedFile}
                />
              )
            },
          ]}/>
        );
      case 'all':
      default:
        return (
          <TabsHolder tabs={[
            {
              id: 0,
              title: 'קבצי הזמנה', //order
              content: (
                <SetOrEmpty
                  files={files.order}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  handleSubmit={handleSubmit}
                  copyFile={copyOrderFile}
                  fileTypeID={fileTypeID}
                  folderID={folderID}
                />
              )
            },
            {
              id: 1,
              title: 'מאגר פנימי', // private
              content: (
                <GridOrEmpty
                  files={files.private}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  fileUploaded={fileUploaded}
                  handleSubmit={handleSubmit}
                  getFile={getPrivateFile}
                  showShumaId={true}
                  copyFile={copyPrivateFile}
                />
              )
            },
            {
              id: 2,
              title: 'מאגר שיתופי', //shared
              content: (
                <GridOrEmpty
                  files={files.shared}
                  shumaID={shumaID}
                  stepID={stepID}
                  closeModal={closeModal}
                  fileUploaded={fileUploaded}
                  handleSubmit={handleSubmit}
                  getFile={getSharedFile}
                  copyFile={copySharedFile}
                />
              )
            },
          ]}/>
        );
    }
  };

  return (
    <AbstractModalView
      subPath={`view-${shumaID}-${fileTypeID}-shared-files`}
      triggerContent={({openModal}) => (
        <div
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal();
            handleGetFilesLists();
          }}
          className={classnames(`${styles.buttonContainer} ${customStylesContainer}`)}
        >
          <img src={filesList} alt="list" className={styles.icon}/>
          <p className={styles.label}>{'בחר'}</p>
        </div>
      )}
      modalContent={({closeModal}) => (
        <div className={styles.modalContainer}>
          <h2 className={styles.modalHeader}>{getPopupHeader(type)}</h2>
          <div className={styles.modalContent}>
            {buildTablesOrTabs(closeModal)}
            <button
              type="button"
              className={styles.buttonCancel}
              onClick={closeModal}
            >
              <span>סגירה</span>
            </button>
          </div>
        </div>
      )}
    />
  );
};

ModalSharedFilesListView.propTypes = {
  shumaID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  stepID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  type: PropTypes.oneOf([
    'private',
    'order',
    'shared',
    'all',
    'order-shared',
    'order-private',
    'shared-private',
  ]),
  files: PropTypes.shape({
    shared: PropTypes.array,
    private: PropTypes.array,
  }),
  handleGetFilesLists: PropTypes.func,
  fileUploaded: PropTypes.bool,
  customStylesContainer: PropTypes.string,
  fileTypeID: PropTypes.number,
  handleSubmit: PropTypes.func
};

export default ModalSharedFilesListView;
